<template lang="pug">
.header-container
  .header-container__item
    a.header-container__logo(@click='goToHome')
      img.header-container__img(:src='logoImage', :alt='portalName')
    h2.header-container__name(v-if='!!portalName', :class='logoTextSize') {{ portalName }}
    .header-container__link(
      v-if='$slots.link',
      :class='[{ container__link_margin: !portalName }, { container__link_small: !!portalName }]'
    )
      slot(name='link')
  .header-container__item(v-if='$slots.personal')
    .header-container__personal.d-felx.align-items-center
      slot(
        name='addConsultations',
        v-if='isAuthorized && hasApiModuleConsultations'
      )
      slot(name='accessibilityMode')
      slot(name='personal')
</template>

<script>
import ExtLink from '@/components/ext/Link.vue';
import checkMobile from '@/mixins/checkMobile';
import isAuthorized from '@/mixins/isAuthorized';

export default {
  mixins: [checkMobile, isAuthorized],

  components: {
    ExtLink,
  },

  computed: {
    hasApiModuleConsultations() {
      return this.$store.getters.hasApiModuleConsultations;
    },
  },
  methods: {
    goToHome() {
      window.location.assign('/');
    },
  },
  props: {
    portalName: {
      type: String,
      default: '',
    },

    logoImage: {
      type: String,
      default: '',
    },

    logoTextSize: {
      type: String,
      default: 'small',
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/stylus/helpers/mediaqueriesStep'

.header-container
  font-family 'Open Sans', sans-serif
  height 100%
  display flex
  flex-wrap wrap
  justify-content space-between

  &__item
    display flex
    align-items center

  &__logo
    cursor pointer
    height 50px
    margin 5px 10px 5px 0

  &__img
    height 100%
    width auto
    display block

  &__name
    font-size 11px
    width 223px
    line-height 1.25
    font-weight 600
    color #171e4b
    display none
    text-transform uppercase

    +desktop()
      display block

    &.small
      width 150px

    &.huge
      width 400px
      font-size 22px

  &__link /deep/ a
    font-size 11px
    line-height 1.8
    font-weight 600
    text-transform uppercase
    color rgba(#000, .5)
    display block
    transition color .2s ease
    position relative

    +tablet-768()
      margin-left 7px
      padding-right 6px
      display inline-block

    &:last-child
      &::after
        width 0

    &::after
      content ''
      width 0
      height 15px
      background-color rgba(#000, .3)
      position absolute

      +tablet-768()
        width 2px
        top 3px
        right -2px

    &:hover
      color #51acff

  &__link
    +phone()
      display none

    &_margin
      margin-left 12px

    &_small /deep/ a
      display block
      line-height 1.8

      &::after
        width 0

  &__personal
    display flex
    justify-content flex-end
    font-size 14px
    font-weight bold
    white-space nowrap

    +phone()
      padding-right 40px
</style>



// WEBPACK FOOTER //
// Top.vue?1aac28a8